import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import SogPage from "@/shared/ui/SogPage.vue";
import SogCard from "@/shared/ui/SogCard.vue";
import {computed, ref} from "vue";
import SogCardTitle from "@/shared/ui/SogCardTitle.vue";
import SogCardContent from "@/shared/ui/SogCardContent.vue";
import SogFlexRow from "@/shared/ui/SogFlexRow.vue";
import SogIcon from "@/shared/ui/SogIcon.vue";
import SogCardActionButton from "@/shared/ui/SogCardActionButton.vue";
import SogCardActions from "@/shared/ui/SogCardActions.vue";
import {useRouter} from "vue-router";
import {useDisplay} from "vuetify";

export default /*@__PURE__*/_defineComponent({
  __name: 'ClaimsPage',
  setup(__props) {

const {mobile} = useDisplay()


const _title = ref("Schaden melden")

const _router = useRouter()


function onWeb() {
  _router.push("/schadenonline")
}

function onEmail() {
  window.location.replace(_is2025.value?"mailto:agent22.schaden@avus-group.com":"mailto:agent22.schaden@vanameyde.com")
}

function onPhone() {
  window.location.replace(_is2025.value?"tel:+494076465099":"tel:+4922195420689")
}

const _is2025 = computed(()=>{
  return new Date()>=new Date(2025,0,1);
})

const _telephone = computed(()=>{
  return _is2025.value?" +49 40 76465099":" +49 221 95420689"
})

const _email = computed(()=>{
  return _is2025.value?"agent22.schaden(at)avus-group.com":"agent22.schaden(at)vanameyde.com"
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SogPage, { id: "page" }, {
    default: _withCtx(() => [
      _createVNode(SogCard, null, {
        default: _withCtx(() => [
          _createVNode(SogCardTitle, null, {
            SubTitle: _withCtx(() => [...(_cache[0] || (_cache[0] = [
              _createTextVNode(" Claims Notification ", -1)
            ]))]),
            default: _withCtx(() => [
              _cache[1] || (_cache[1] = _createTextVNode(" Schaden melden ", -1))
            ]),
            _: 1
          }),
          _createVNode(SogCardContent, null, {
            default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
              _createTextVNode(" Melden Sie hier ganz einfach Ihren Schaden.", -1),
              _createElementVNode("br", null, null, -1),
              _createTextVNode(" Simply report your claim here. ", -1)
            ]))]),
            _: 1
          }),
          _createVNode(SogCardContent, null, {
            default: _withCtx(() => [
              _createVNode(SogFlexRow, null, {
                default: _withCtx(() => [
                  _createVNode(SogCard, null, {
                    default: _withCtx(() => [
                      _createVNode(SogCardTitle, null, {
                        default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                          _createTextVNode(" Phone ", -1)
                        ]))]),
                        _: 1
                      }),
                      _createVNode(SogCardContent, null, {
                        default: _withCtx(() => [
                          _createVNode(SogIcon, { icon: "mdi-phone-classic" }),
                          _createTextVNode(" " + _toDisplayString(_telephone.value), 1)
                        ]),
                        _: 1
                      }),
                      _withDirectives(_createVNode(SogCardActions, null, {
                        default: _withCtx(() => [
                          _createVNode(SogCardActionButton, {
                            "mdi-icon": "mdi-phone-classic",
                            onClick: onPhone
                          })
                        ]),
                        _: 1
                      }, 512), [
                        [_vShow, _unref(mobile)]
                      ])
                    ]),
                    _: 1
                  }),
                  _withDirectives(_createVNode(SogCard, null, {
                    default: _withCtx(() => [
                      _createVNode(SogCardTitle, null, {
                        default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                          _createTextVNode(" Online ", -1)
                        ]))]),
                        _: 1
                      }),
                      _createVNode(SogCardContent, null, {
                        default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                          _createTextVNode("Sie werden an den Schadendienstleister weitergeleitet.", -1)
                        ]))]),
                        _: 1
                      }),
                      _createVNode(SogCardActions, null, {
                        default: _withCtx(() => [
                          _createVNode(SogCardActionButton, {
                            "mdi-icon": "mdi-web",
                            onClick: onWeb
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 512), [
                    [_vShow, !_is2025.value]
                  ]),
                  _createVNode(SogCard, null, {
                    default: _withCtx(() => [
                      _createVNode(SogCardTitle, null, {
                        default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                          _createTextVNode(" E-mail ", -1)
                        ]))]),
                        _: 1
                      }),
                      _createVNode(SogCardContent, null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_email.value), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(SogCardActions, null, {
                        default: _withCtx(() => [
                          _createVNode(SogCardActionButton, {
                            "mdi-icon": "mdi-at",
                            onClick: onEmail
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})